require("./inputsfield/input-text")
require('./forms/form-dekaz')
require('./forms/form-dekaz-demo')
require('./forms/form_v2')
require('./forms/form-dekazBGC')
require('./popup/_popup')